import { marqueeItems } from "@/data/content";

export const Marquee = () => (
  <div className="bg-white border-y border-slate-200/80 py-4 overflow-hidden" aria-hidden="true" data-testid="expertise-marquee">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0">
          {marqueeItems.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center whitespace-nowrap">
              <span className="font-serif text-slate-400 text-lg px-6">{item}</span>
              <span className="text-teal-500 text-xs">&#9679;</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
